/**
 * ============================================================
 * Mining Survey WebGIS
 * Main Application
 * ============================================================
 */

import CONFIG from "./config/config.js";

import AppState from "./core/app.js";

import Map from "./modules/map.js";

import GPS from "./modules/gps.js";

import UI from "./modules/ui.js";

import Track from "./modules/track.js";

import Project from "./modules/project.js";

import Basemap from "./modules/basemap.js";

import Identify from "./modules/identify.js";

class Application {
    async start() {
        console.clear();

        console.log(CONFIG.APP.NAME);

        console.log(CONFIG.APP.VERSION);

        AppState.followMode = CONFIG.GPS.FOLLOW;
        Map.updateFollowButton();

        Map.init();

        // Load project configuration
        await Project.load();

        // Load default basemap
        await Basemap.load();

        Identify.init();

        // Simpan layer basemap ke AppState
        AppState.layers.raster.basemap = Basemap.getLayer();

        UI.init();

        GPS.init();

        Track.reset();

        this.updateTrackButtons();
        UI.enableSaveButton(false);

        document
            .getElementById("btnLocate")

            .addEventListener(
                "click",

                () => {
                    Map.locateCurrentPosition();
                },
            );

        document
            .getElementById("btnFollow")

            .addEventListener(
                "click",

                () => {
                    AppState.followMode = !AppState.followMode;

                    Map.updateFollowButton();
                },
            );

        document
            .getElementById("btnRecord")

            .addEventListener("click", () => {
                Track.start();

                this.updateTrackButtons();
            });

        document
            .getElementById("btnPause")

            .addEventListener("click", () => {
                if (Track.getState() === "paused") {
                    Track.resume();
                } else {
                    Track.pause();
                }

                this.updateTrackButtons();
            });

        document
            .getElementById("btnStop")

            .addEventListener("click", () => {
                Track.stop();

                this.updateTrackButtons();
            });

        this.startRefresh();
    }

    startRefresh() {
        setInterval(() => {
            if (!AppState.currentPosition) return;

            UI.updatePosition(AppState.currentPosition);
        }, 250);
    }

    updateTrackButtons() {
        const record = document.getElementById("btnRecord");
        const pause = document.getElementById("btnPause");
        const stop = document.getElementById("btnStop");

        const recordIcon = record.querySelector("i");
        const pauseIcon = pause.querySelector("i");

        switch (Track.getState()) {
            case "idle":
                record.disabled = false;
                pause.disabled = true;
                stop.disabled = true;

                recordIcon.className = "bi bi-record-circle";
                pauseIcon.className = "bi bi-pause-circle";

                break;

            case "recording":
                record.disabled = true;
                pause.disabled = false;
                stop.disabled = false;

                pauseIcon.className = "bi bi-pause-circle";

                break;

            case "paused":
                record.disabled = true;
                pause.disabled = false;
                stop.disabled = false;

                pauseIcon.className = "bi bi-play-circle";

                break;
        }
    }
}

export default new Application();
